import { useAuth0 } from "@auth0/auth0-react";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import Spinner from "components/spinner";
import AuthService from "Lib/API/Auth";
import MemberService from "Lib/API/Member";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { filterState, getFilterData } from "./NewFilter/filterSlice";

const Filter = ({ from }) => {
  const history = useHistory();
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const [deletefilterId, setFilterId] = useState();
  const [filterData, setFilterData] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      MemberService.getFilter(token)
        .then((res) => {
          setFilterData(res);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }, [getAccessTokenSilently, history]);

  const myHandleClick = async (id, filterName) => {
    const token = await getAccessTokenSilently();
    dispatch(getFilterData({ id, token: token }));
    dispatch(filterState("results"));
    history.push({
      pathname: "/create-new-filter",
      state: {
        value: filterName,
      },
    });
  };
  const handleDelete = async (id) => {
    const token = await getAccessTokenSilently();
    await AuthService.removeFilter({ filterId: id }, token);
    await MemberService.getFilter(token)
      .then((res) => {
        setFilterData(res);
        setOpenDialog(false);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  return (
    <div className="filter">
      <div className="filter-header">Filters</div>
      <div style={{ margin: "20px 0 10px 0", fontSize: "20px" }}>
        Choose from pre-saved filters
      </div>
      <div
        style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
      >
        {loading ? (
          <Spinner
            styles={{
              margin: "0px auto",
              color: "#2555ef",
            }}
          />
        ) : (
          filterData?.map((item, index) => {
            return (
              <div
                key={index}
                className={
                  filterData.length < 2 ? "single-filter" : "filter-option"
                }
              >
                <div className="choose-action-filter">
                  <Action
                    style={{ cursor: "pointer" }}
                    onEditClick={() =>
                      history.push(`/create-new-filter?id=${item._id}`)
                    }
                    // eslint-disable-next-line no-unused-expressions
                    onDeleteClick={() => {
                      setOpenDialog(true);
                      setFilterId(item);
                    }}
                  />
                </div>
                <div
                  className="pre-filter-name"
                  onClick={() => myHandleClick(item?._id, item?.filterName)}
                >
                  {item.filterName}
                </div>
                <AlertDialog
                  open={openDialog}
                  onDecline={() => setOpenDialog(false)}
                  onAccept={() => handleDelete(deletefilterId?._id)}
                  title={`Are you sure?`}
                  description={`Do you want to delete this filter?`}
                />
              </div>
            );
          })
        )}
      </div>
      {from !== "resultFilter" ? (
        <>
          <hr />
          <div className="divider">OR</div>
          <div className="create-button">
            <MyButton
              content="Create New Filter"
              onClick={() => {
                history.push("/create-new-filter");
              }}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Filter;
